module.exports = __webpack_public_path__ + "static/costco-56406d15d863173128ea189a23f40632.png";